// extracted by css-extract-rspack-plugin
export default {"options":"options-qyAsFt"};